<template>
    <div>
        <div>
            <el-input v-model="pair" placeholder="请输入交易对" style="width: 300px"></el-input>
            <el-select v-model="cycle" placeholder="请选择周期">
                <el-option v-for="item in cycleArr" :key="item.id" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-button type="primary" style="margin-left: 30px" @click="deleteKcache">删除k线缓存</el-button>
        </div>

        <div style="margin-top: 30px">
            <el-input v-model="orderNo" placeholder="请输入订单号" style="width: 300px"></el-input>
            <el-button type="primary" style="margin-left: 30px" @click="deleteRepeatCancelKey">删除撤单重复请求key</el-button>
        </div>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: 'Cache',
        data() {
            return {
                orderNo: "",
                cycle: "",
                pair: "",
                cycleArr: [
                    {id: 0, label: "全部", value: ""},
                    {id: 1, label: "1分钟", value: 1},
                    {id: 2, label: "5分钟", value: 5},
                    {id: 3, label: "15分钟", value: 15},
                    {id: 4, label: "30分钟", value: 30},
                    {id: 5, label: "1小时", value: 60},
                    {id: 6, label: "4小时", value: 240},
                    {id: 7, label: "6小时", value: 360},
                    {id: 8, label: "12小时", value: 720},
                    {id: 9, label: "1天", value: 1440},
                    {id: 10, label: "1周", value: 10080},
                ]
            };
        },
        methods: {
            deleteKcache() {
                if (this.pair == "") {
                    this.$message.error('请输入交易对!');
                    return;
                }
                api.kline({pair: this.pair, cycle: this.cycle}).then(({data}) => {
                    this.$message.success('删除k线缓存成功!');
                });
            },
            deleteRepeatCancelKey() {
                if (this.orderNo == "") {
                    this.$message.error('请输入订单号!');
                    return;
                }
                api.order({orderNo: this.orderNo}).then(({data}) => {
                    this.$message.success('删除撤单重复请求key成功!');
                });
            }
        },
        created() {
        }
    };
</script>

<style lang="less" scoped>
</style>

